<script setup lang="ts">
/* eslint-disable perfectionist/sort-modules */
/* eslint-disable perfectionist/sort-imports */
/* eslint-disable no-unused-vars */
import {
  computed,
  onMounted,
  onUnmounted,
  ref,
} from 'vue';

import Navbar from '~/partials/Navbar.vue';
import Sidebar from '~/partials/Sidebar.vue';
import useSidebar from '~/hooks/useSidebar';

// Use global sidebar state
const { isCollapsed } = useSidebar();

// Track window size
const windowWidth = ref(window.innerWidth);

const updateWindowSize = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener('resize', updateWindowSize);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateWindowSize);
});

// Dynamic margin calculation
const contentMargin = computed(() => {
  // No margin on mobile
  if (windowWidth.value < 992) return '0';

  // Desktop margins based on sidebar state
  return isCollapsed.value ? '70px' : '280px';
});
</script>

<template>
  <div class="page">
    <Sidebar />
    <div
      class="page-wrapper"
      :style="{
        marginLeft: contentMargin,
        transition: 'margin-left 0.3s ease',
      }"
    >
      <Navbar />
      <div class="page-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.page {
  min-height: 100vh;
  background-color: #f8fafc;
}
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-body {
  flex: 1;
  position: relative;
}

/* Mobile responsive - remove margin on mobile */
@media (max-width: 991px) {
  .page-wrapper {
    margin-left: 0 !important;
  }
}
</style>
